import { CHECKOUT_URL } from "../../data/academyData";

export const StickyMobileCTA = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-black/95 backdrop-blur-xl border-t border-rose-500/30 px-4 py-3 flex items-center justify-between gap-4">
    <div>
      <p className="text-xs text-zinc-500 line-through">₹9,999</p>
      <p className="font-heading text-xl font-bold text-white leading-none">₹999</p>
    </div>
    <a
      href={CHECKOUT_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-mobile-cta-button"
      className="flex-1 text-center rounded-full bg-rose-600 text-white font-semibold py-3 px-4 shadow-[0_0_20px_rgba(229,9,20,0.4)]"
    >
      Join AX Academy Now
    </a>
  </div>
);
